<template>
  <page-outline :title="$t('businessDocuments.cntcts_lst')">
    <template slot="pageContent">
      <!-- <div class="page rowBackgroundHomepage"> -->
        <div v-if="isSmartphoneOS">
          <f7-navbar class="position-absolute t-44px" v-if="false">
            <b-row class="text-center w-100 no-gutters">
              <div>
                <b-button variant="primary" class="statusButton"
                  :class="currentRole === 'simple' ? 'navbar-button-selected': 'navbar-button'"
                  @click="changeCurrentRole('simple')"
                  tab-link=".contactTab1">
                  {{ $t('common.contacts_label') }}
                </b-button>
              </div>
              <div>
                <b-button variant="primary" class="statusButton"
                  :class="currentRole === 'group' ? 'navbar-button-selected': 'navbar-button'"
                  @click="changeCurrentRole('group')"
                  tab-link=".contactTab2">
                  {{ $t('common.groups_label') }}
                </b-button>
              </div>
            </b-row>
          </f7-navbar>
        </div>

        <!-- <div class="page-content"> -->
          <!-- <div class="layoutTop" v-if="!isSmartphoneOS"></div>
          <div v-else-if="false" style="height:132px;"></div>
          <div v-else style="height:88px;"></div> -->
          <div class="listPage">
            <b-row v-if="!isSmartphoneOS && false">
              <b-col>
                <div class="contactButtonContainer">
                  <f7-grid no-gutter>
                    <f7-col width="50" class="pilotageTabController">
                      <f7-link class="pilotageLink border-top-left-radius-10px"
                        :class="{tabActive: currentRole === 'simple', tabUnactive: currentRole !== 'simple'}"
                        tab-link=".contactTab1"
                        @click="changeCurrentRole('simple')" active>
                        {{ $t('common.contacts_label') }}
                      </f7-link>
                    </f7-col>
                    <f7-col width="50" class="pilotageTabController">
                      <f7-link class="pilotageLink border-top-left-radius-10px"
                        :class="{tabActive: currentRole === 'group', tabUnactive: currentRole !== 'group'}"
                        tab-link=".contactTab2"
                        @click="changeCurrentRole('group')">
                        {{ $t('common.groups_label') }}
                      </f7-link>
                    </f7-col>
                  </f7-grid>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div v-if="activateSpinner">
                  <spinner></spinner>
                </div>
                <f7-tabs v-else>
                  <b-row class="my-3 justify-content-start align-items-center">
                    <b-col xl="2" cols="12" sm="4" v-if="currentRole === 'simple'">
                      <b-button variant="secondary"
                                @click="OpenFormsPageContact"
                                :disabled="canAdd">
                        <i class="fa-light fa-plus fs-17px"></i>
                        <span>{{ $t('common.add_label') }}</span>
                      </b-button>
                    </b-col>
                    <b-col xl="2" cols="12" sm="4">
                    </b-col>
                    <b-col xl="2" cols="12" sm="4" v-if="currentRole === 'group'">
                      <b-button variant="secondary"
                                @click="OpenFormsPageContactGroup">
                        <i class="fa-light fa-plus fs-17px"></i>
                        <span>{{ $t('common.add_label') }}</span>
                      </b-button>
                    </b-col>
                    <b-col cols="8" sm="4" class="d-flex justify-content-center">
                      <f7-searchbar
                          class="search webdatalist"
                          :cancel-link="$t('common.cncl')"
                          search-list="#contacts-list"
                          :placeholder="searchInLabel"
                          :clear-button="true"
                          @searchbar:search="onSearch"
                          @searchbar:clear="onClear">
                      </f7-searchbar>
                    </b-col>
                  </b-row>
                  <f7-tab class="contactTab1" active>
                    <div class="itemList">
                      <cm-contact-list :filterBy="filterBy" :contacts="contacts" :key="refreshKey"></cm-contact-list>
                    </div>
                  </f7-tab>
                  <f7-tab class="contactTab2">
                    <f7-searchbar v-if="!isSmartphoneOS"
                      class="webdatalist"
                      cancel-link="Cancel"
                      search-list="#group-list"
                      :placeholder="searchInLabel"
                      @searchbar:search="onGroupSearch"
                      @searchbar:clear="onGroupClear">
                    </f7-searchbar>
                    <div class="itemList">
                      <cm-contact-group-list :filterBy="groupFilterBy" :contactGroups="contactGroups" :key="refreshKey"></cm-contact-group-list>
                    </div>
                  </f7-tab>
                </f7-tabs>
              </b-col>
            </b-row>
            <div class="toolbarPageBottomBlankContactPage"></div>
          </div>
        <!-- </div> -->
      <!-- </div> -->
    </template>
  </page-outline>
</template>

<script>
import moment from 'moment'

import PageOutline from '@/components/common/PageOutline.vue'

import ContactGroupList from './CMContactsPage/CMContactGroupList.vue'
import ContactList from './CMContactsPage/CMContactList.vue'

import Spinner from '@/components/common/spinner.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import { downloadFileWithDefinedHeaders } from '@/helpers/download'

export default {
  name: 'contacts',
  components: {
    'cm-contact-group-list': ContactGroupList,
    'cm-contact-list': ContactList,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  data () {
    return {
      activateSpinner: false,
      backgroundColor: '',
      canImport: false,
      contactGroups: [],
      contactListLabel: '',
      contacts: [],
      currentRole: 'simple',
      filterBy: '',
      groupFilterBy: '',
      importLabel: '',
      multipleContactsDelete: [],
      refreshKey: false,
      service: ''
    }
  },
  created () {
    let that = this
    this.activateSpinner = true
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: this.$i18n.t('Webheader.my_contacts'),
      returnUrl: ''
    })
    this.importLabel = this.$i18n.t('common.import_contacts')
    this.contactListLabel = this.$i18n.t('common.contacts_list')
    /* Turn off all buses events */
    // this.$bus.$off('inbox-filtered')
    this.$bus.$off('sendbox-filtered')
    // this.$bus.$off('refresh-cache-service')
    this.$bus.$off('refresh-cache-bank-accounts')
    this.$bus.$off('refresh-cache-contacts')
    this.$bus.$off('refresh-cache-groups')
    // this.$bus.$off('refresh-cache-attachments-view')
    this.$bus.$off('refresh-cache-attachments')
    this.$bus.$off('refresh-cache-account-members')
    this.$bus.$off('refresh-inbox-list-cache')
    this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage
    this.$bus.$on('refresh-cache-contacts', (index) => {
      that.getContacts(index)
    })
    this.$bus.$on('refresh-cache-groups', (index) => {
      this.setContactGroups(index)
    })
    that.getContacts()
    this.setContactGroups()
    that.$$(document).off('taphold', '.blueConfirmationButtonActivationOK2')
    that.$$(document).on('taphold', '.testTap', function () {
      if (that.multipleContactsDelete.includes(that.$$(this).data('item')) === false) {
        that.multipleContactsDelete.push(that.$$(this).data('item'))
        that.$$(this).addClass('listItemSelected')
      } else if (that.multipleContactsDelete.includes(that.$$(this).data('item')) === true) {
        let index = that.multipleContactsDelete.indexOf(that.$$(this).data('item'))
        if (index > -1) {
          that.multipleContactsDelete.splice(index, 1)
        }
        that.$$(this).removeClass('listItemSelected')
      }
    })
    this.service = this.$engine.user.currentService.name
  },
  mounted () {
  },
  computed: {
    canAdd () {
      return this.$engine.rights.rightIs('contact_ajouter', false)
    },
    getColor: function () {
      return 'tabActive'
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    searchInLabel () {
      if (this.currentRole === 'group') {
        return this.$i18n.t('contacts.srch_in_grps')
      } else {
        return this.$i18n.t('contacts.srch_in_cntcts')
      }
    }
  },
  methods: {
    onSearch: function (query, found) {
      this.filterBy = query
      this.getContacts()
    },
    onClear: function () {
      this.filterBy = ''
    },
    extractCSV (contacts, contactGroups) {
      let firstLine = ''
      let lines = ''
      let fileName = ''
      let today = moment()
      let serviceFileName = ''
      if (this.service === 'Direct Debit') {
        serviceFileName = 'ModularLoan'
      } else if (this.service === 'Direct Payments') {
        serviceFileName = 'DirectPayments'
      } else {
        serviceFileName = 'RequestToPay'
      }
      if (this.currentRole === 'simple') {
        firstLine = this.$i18n.t('common.als') + ';' + this.$i18n.t('common.nme') + '\r\n'
        fileName = 'contact' + serviceFileName + today.unix() + '.csv'
        for (var kc in contacts) {
          for (var kkc in contacts[kc]) {
            lines += contacts[kc][kkc].label + ';' + contacts[kc][kkc].name + '\r\n'
          }
        }
      } else {
        firstLine = this.$i18n.t('common.als') + '\r\n'
        fileName = 'contactGroup' + serviceFileName + today.unix() + '.csv'
        for (var kcg in contactGroups) {
          for (var kkcg in contactGroups[kcg]) {
            lines += contactGroups[kcg][kkcg].label + '\r\n'
          }
        }
      }
      let data = firstLine + lines

      let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      let downloadLink = document.createElement('a')
      if (
        this.$f7.device.os === 'android' ||
        this.$f7.device.os === 'ios'
      ) {
        downloadFileWithDefinedHeaders(this, fileName, linkSource)
      } else {
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
      }
      this.$f7.alert('', this.$i18n.t('common.exprt_succ'))
    },
    getContacts (index) {
      let contactsList
      let contactsGot
      this.$engine.contacts.fetch()
      .then(resp => {
        contactsGot = resp.data
        contactsList = contactsGot.contacts
        this.setContacts(index, contactsList)
      })

    },
    onGroupSearch (query, found) {
      this.groupFilterBy = query
      this.setContactGroups()
    },
    onGroupClear () {
      this.groupFilterBy = ''
    },
    changeCurrentRole (role) {
      if (this.currentRole !== role) {
        this.currentRole = role
      }
    },
    setContacts (index = 1, contactsList) {
      var contactList = {}
      let nbElement = 0
      let that = this
      contactsList.forEach(contact => {
        if (contact.label.toLowerCase().includes(that.filterBy.toLowerCase())
          || contact.name.toLowerCase().includes(that.filterBy.toLowerCase())) {
            const firstLetter = contact.label.substr(0, 1).toUpperCase()
            if (!contactList.hasOwnProperty(firstLetter)) {
              contactList[firstLetter] = []
            }
            contactList[firstLetter].push({
              id: contact.id,
              label: contact.label,
              iban: contact.iban,
              identifier: contact.identifier,
              name: contact.name,
              phoneNumber: contact.phoneNumber,
              address: contact.address,
              city: contact.city,
              zipCode: contact.zipCode,
              country: contact.country,
              typeContact: contact.typeContact,
              zoneCode: contact.zoneCode,
              idCompany: contact.idCompany,
              idProvider: contact.idProvider
            })
            contactList[firstLetter].sort()
          }
      })
      this.contacts = this.orderKeys(contactList)
      this.refreshKey = !this.refreshKey
      this.activateSpinner = false
    },
    setContactGroups (index = 1) {
      var contactGroupList = {}
      let nbElement = 0
      for (var j = 0; j < this.$engine.contacts.getContactGroup().length; j++) {
        var contactGroup = this.$engine.contacts.getContactGroup(j)
        if (contactGroup.label.toLowerCase().includes(this.groupFilterBy.toLowerCase()) || contactGroup.name.toLowerCase().includes(this.filterBy.toLowerCase())) {
          var firstLetter = contactGroup.label.substr(0, 1).toUpperCase()
          if (!contactGroupList.hasOwnProperty(firstLetter)) {
            contactGroupList[firstLetter] = []
          }
          contactGroupList[firstLetter].push({
            label: contactGroup.label,
            contacts: contactGroup.contacts,
            id: contactGroup.id
          })
          contactGroupList[firstLetter].sort()
        }
      }
      this.contactGroups = this.orderKeys(contactGroupList)
    },
    orderKeys (obj) {
      // return {}
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })
      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }
      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    OpenFormsPageContact () {
      this.clearPage()
      loadPage(this, {url: '/account/addContact/'})
    },
    OpenFormsPageContactGroup () {
      loadPage(this, {url: '/account/addContactGroup/'})
    },
    // OpenFormsPageContact () {
    //   if (this.Dom7('#simpleContact').last().hasClass('active')) {
    //     this.clearPage()
    //     loadPage(this, {url: '/account/addContact/'})
    //   } else if (this.Dom7('#contactGroup').last().hasClass('active')) {
    //     loadPage(this, {url: '/account/addContactGroup/'})
    //   }
    // },
    deleteMultipleContacts () {
      let that = this
      that.$f7.confirm('Are you sure to delete these contacts?', 'Operation confirmation', function () {
        that.$engine.contacts.deleteMultipleContacts(that.multipleContactsDelete)
        .then(resp => {
          that.$f7.modal({
            title: 'Contacts deleted',
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.multipleContactsDelete = []
            that.$f7.closeModal()
            that.$bus.$emit('refresh-cache-contacts')
            loadPage(that, {url: '/contacts/', force: false, ignoreCache: false})
          }, 2000)
        })
        .catch(err => {
          errorMessageAlert(err, that)
        })
      })
    },
    clearPage () {
      this.$$('.testTap').removeClass('listItemSelected')
      // this.$$('#contactDeleteButton').css('visibility', 'hidden')
      this.multipleContactsDelete = []
    },
    mobileSearchbarClicked(){
      console.log('mobile searchbar clicked');
    }
  }
}
</script>
